import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Subscriptions from "./pages/Subscriptions";
import EditInvoice from "./pages/EditInvoice";
import Jobs from "./pages/Jobs";
import JobDetails from "./pages/JobDetails";
import Packages from "./pages/Packages";
import AddPackage from "./pages/AddPackage";
import EditPackage from "./pages/EditPackage";
import Usage from "./pages/Usage";
import UsageDetail from "./pages/UsageDetail";
import TalentFinder from "./pages/TalentFinder";
import Activity from "./pages/Activity";
import CountriesIndustries from "./pages/CountriesIndustries";
import Emails from "./pages/Emails";
import AppSettings from "./pages/AppSettings";
import MaintenanceSettings from "./pages/MaintenanceSettings";
import WeightTemplates from "./pages/WeightTemplates";
import ContactBilling from "./pages/ContactBilling";
import MasterVariables from "./pages/MasterVariables";
import GuestUsage from "./pages/GuestUsage";
import CVs from "./pages/CVs";
import PromoCodes from "./pages/PromoCodes";
import AISettings from "./pages/AISettings";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscriptions"
            element={
              <ProtectedRoute>
                <Subscriptions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscriptions/edit/:id"
            element={
              <ProtectedRoute>
                <EditInvoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <Jobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/:id"
            element={
              <ProtectedRoute>
                <JobDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cvs"
            element={
              <ProtectedRoute>
                <CVs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/packages"
            element={
              <ProtectedRoute>
                <Packages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/packages/add"
            element={
              <ProtectedRoute>
                <AddPackage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/packages/edit/:id"
            element={
              <ProtectedRoute>
                <EditPackage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/app"
            element={
              <ProtectedRoute>
                <AppSettings />
              </ProtectedRoute>
            }
          />
          {/* Redirect old packages route to new location */}
          <Route
            path="/packages"
            element={<Navigate to="/settings/packages" replace />}
          />
          <Route
            path="/usage"
            element={
              <ProtectedRoute>
                <Usage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usage/:id"
            element={
              <ProtectedRoute>
                <UsageDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/talent-finder"
            element={
              <ProtectedRoute>
                <TalentFinder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/guest-usage"
            element={
              <ProtectedRoute>
                <GuestUsage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/activity"
            element={
              <ProtectedRoute>
                <Activity />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/countries-industries"
            element={
              <ProtectedRoute>
                <CountriesIndustries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/emails"
            element={
              <ProtectedRoute>
                <Emails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/maintenance"
            element={
              <ProtectedRoute>
                <MaintenanceSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/weight-templates"
            element={
              <ProtectedRoute>
                <WeightTemplates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/contact-billing"
            element={
              <ProtectedRoute>
                <ContactBilling />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/master-variables"
            element={
              <ProtectedRoute>
                <MasterVariables />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/promo-codes"
            element={
              <ProtectedRoute>
                <PromoCodes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/ai-models"
            element={
              <ProtectedRoute>
                <AISettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={<Navigate to="/settings/countries-industries" replace />}
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
